import {
  Divider,
  ListItem,
  ListItemText,
  makeStyles,
  Theme,
} from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";

interface Props {
  name: string;
  label: string;
  description?: string;
  onClick: (reportName: string) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  reportItem: {
    cursor: "pointer",
    transition: "background-color 150ms ease",
    "&:hover": {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

export const ReportItem = ({ label, description, name, onClick }: Props) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <>
      <ListItem className={classes.reportItem} onClick={() => onClick(name)}>
        <ListItemText
          primary={translate(label, { _: label })}
          secondary={
            description ? translate(description, { _: description }) : null
          }
        />
      </ListItem>
      <Divider />
    </>
  );
};
